import React from 'react';
import { connect } from 'react-redux';
import Spinner from 'react-spinkit';
import Promo from '../promo';
import { showPromo } from '../promo/actions';
import Text from 'components/ui/text';
import View from 'components/ui/view';

const renderPromoValue = code => {
  if (!code) return '';
  switch (code.value_type) {
    case '%':
      return `${100 * code.value}% Off`;
    case 'hour':
      return code.value === 1 ? `${code.value} Hour` : `${code.value} Hours`;
    default:
      return `$${code.value}`;
  }
};

const renderPromoCode = code => {
  return (
    <div key={code.code} className="promo-code-row">
      <div className="row middle-xs">
        <div className="col-xs-9">
          <Text weight="bold">{code.label}</Text>
          <div>{code.desc}</div>
        </div>
        <div className="col-xs-3">
          <div className="text-right">{renderPromoValue(code)}</div>
        </div>
      </div>
    </div>
  );
};

const GiftCredit = ({ amount }) => (
  <div className="promo-code-row">
    <div className="row middle-xs">
      <div className="col-xs-9">
        <View margin="sm">
          <Text success weight="bold">
            Available Gift Credit
          </Text>
        </View>
      </div>
      <div className="col-xs-3">
        <View margin="sm">
          <Text success className="text-right">
            ${amount}
          </Text>
        </View>
      </div>
    </div>
  </div>
);

class Promos extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.props.showPromo(true);
  }

  closeModal() {
    this.props.showPromo(false);
  }

  render() {
    return (
      <div>
        {this.state.loading && (
          <div className="loading-container row center-xs middle-xs">
            <Spinner spinnerName="three-bounce" noFadeIn />
          </div>
        )}

        {!!this.props.credit && (
          <GiftCredit amount={this.props.credit.balance} />
        )}

        {this.props.codes.map(renderPromoCode)}

        <div className="row">
          <div className="col-xs-12">
            <button
              type="button"
              className="btn-primary btn-block"
              onClick={this.openModal}
            >
              Add Promo or Gift Card
            </button>
          </div>
        </div>

        <Promo />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { ...state.promo };
}

export default connect(mapStateToProps, { showPromo })(Promos);



// WEBPACK FOOTER //
// ./shared/components/account/promos.js